import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';

export const ConsumoMedio = (props) => (
  <Card
    sx={{ height: '100%' }}
    {...props}
  >
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="overline"
          >
            Consumo medio
          </Typography>
          <Typography
            color="textPrimary"
            variant="h4"
          >
            {props.consumoMedio?
            props.consumoMedio.toFixed(2) + " l/h"
          :
          ""} 
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: '#7e57c2',
              height: 56,
              width: 56
            }}
          >
            <TimelineIcon />
          </Avatar>
        </Grid>
      </Grid>
      <Box
        sx={{
          pt: 2,
          display: 'flex',
          alignItems: 'center'
        }}
      >
      </Box>
    </CardContent>
  </Card>
);
